import React, { forwardRef } from 'react';
import { DeviceCardElement, DeviceCardContainer, IconContainer, } from './deviceCardBodyElements';
import { Tag } from '../Tag';
import { Text } from '../Text';
import { Icon } from '../Icon';
import { InternalProvider } from '../../util/InternalProvider';
export var DeviceCardBody = forwardRef(function (_a) {
    var iconSrc = _a.iconSrc, primary = _a.primary, secondary = _a.secondary, tertiary = _a.tertiary, tagType = _a.tagType, tagText = _a.tagText;
    return (React.createElement(InternalProvider, null,
        React.createElement(DeviceCardContainer, null,
            iconSrc && (React.createElement(IconContainer, null,
                React.createElement(Icon, { src: iconSrc, className: "card-body__icon" }))),
            primary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 2, weight: "heavy" }, primary))),
            secondary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 1 }, secondary))),
            tertiary && (React.createElement(DeviceCardElement, null,
                React.createElement(Text, { size: 1 }, tertiary))),
            tagText && (React.createElement(DeviceCardElement, null,
                React.createElement(Tag, { text: tagText, type: tagType, size: "small" }))))));
});
